/* PJC v14 — Carrousel des avis (section « Vos petits mots doux »).
   Défilement natif (scroll-snap) + boutons précédent/suivant + points de page.
   Aucune dépendance, aucun conflit : tout est scopé à [data-pjc-carousel]. Fonctionne sans JS (la liste défile au doigt). */
(function () {
  'use strict';

  function setup(root) {
    if (root.dataset.pjcReady) return;
    root.dataset.pjcReady = '1';

    var track = root.querySelector('[data-pjc-track]');
    var prev = root.querySelector('[data-pjc-prev]');
    var next = root.querySelector('[data-pjc-next]');
    var dots = root.querySelector('[data-pjc-dots]');
    if (!track) return;

    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var behavior = function () { return reduce.matches ? 'auto' : 'smooth'; };

    function perView() {
      var w = items[0].getBoundingClientRect().width;
      if (!w) return 1;
      return Math.max(1, Math.round(track.clientWidth / w));
    }

    function pageCount() {
      return Math.max(1, Math.ceil(items.length / perView()));
    }

    function currentPage() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return 0;
      var ratio = track.scrollLeft / max;
      return Math.round(ratio * (pageCount() - 1));
    }

    function buildDots() {
      if (!dots) return;
      dots.innerHTML = '';
      var n = pageCount();
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pjc-rvc__dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Page ' + (i + 1) + ' sur ' + n);
        b.dataset.page = String(i);
        b.addEventListener('click', function (e) {
          goTo(Number(e.currentTarget.dataset.page));
        });
        dots.appendChild(b);
      }
      root.hidden = false;
      root.classList.toggle('pjc-rvc--single', n < 2);
    }

    function update() {
      var page = currentPage();
      var n = pageCount();
      if (dots) {
        Array.prototype.forEach.call(dots.children, function (d, i) {
          var on = i === page;
          d.setAttribute('aria-selected', on ? 'true' : 'false');
          d.classList.toggle('is-on', on);
        });
      }
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2 || n < 2;
    }

    function goTo(page) {
      var n = pageCount();
      page = Math.max(0, Math.min(n - 1, page));
      var max = track.scrollWidth - track.clientWidth;
      var left = n > 1 ? (max * page) / (n - 1) : 0;
      track.scrollTo({ left: left, behavior: behavior() });
    }

    if (prev) prev.addEventListener('click', function () { goTo(currentPage() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentPage() + 1); });

    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentPage() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentPage() - 1); }
    });

    var resizeTimer = 0;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { buildDots(); update(); }, 120);
    });

    buildDots();
    update();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pjc-carousel]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Éditeur de thème : la section peut être re-rendue. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
